import { MDBListGroupItem } from "mdbreact";
import { NavLink } from "react-router-dom";

interface Props {
    icon: any,
    label: string,
    link: string,
    hasAccess: boolean
}

const accessDeniedUrl = '/noaccess';

const TopNavigationItem = (props: Props) => {
    if (props.hasAccess) {
        return (
            <NavLink to={props.link} activeClassName="activeClass">
                <a
                    rel="noopener noreferrer"
                    className="nav-link Ripple-parent"
                    href="https://mdbootstrap.com/react/5-min-quick-start/"
                    target="_blank"
                >
                    <img src={props.icon} />
                    {props.label}
                </a>
            </NavLink>
        );
    }
    else {

        return <></>;
        /*
        return (
            <NavLink to={accessDeniedUrl} activeClassName="">
                <a
                    rel="noopener noreferrer"
                    className="nav-link Ripple-parent disabledElementWithOpacity"
                    href="https://mdbootstrap.com/react/5-min-quick-start/"
                    target="_blank"
                >
                    <img src={props.icon} />
                    {props.label}
                </a>
            </NavLink>
        );
        */
    }
}

export default TopNavigationItem;